<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-chart-line"></i> Relatórios - Despesas</h3>
      </div>
    </div>
    <Tables ref="tableGrid"
            :columns="columns"
            :showSearch="true"
            :showReload="false"
            :showTipFooter="false"
            v-on:Search="onShowSearch"
            v-on:Load="onLoadAll"
            v-on:Reload="onLoadAll">
      <template slot="table-header-buttons">
        <a href="javascript:void(0);" v-b-tooltip.hover :title="'Exportar'" @click="onExport">
          <i class="fas fa-file-excel text-third" style="font-size: 15px"></i>
        </a>
      </template>
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <template>
          <TableColumn :IsText="true" :status="1" :value="obj.dataDeslocamento && new Date(obj.dataDeslocamento).toLocaleDateString('pt-BR')" />
          <TableColumn :IsText="true" :status="1" :value="obj.dataDeslocamento && new Date(obj.dataDeslocamento).toLocaleTimeString('pt-BR')" />
          <TableColumn :IsText="true" :status="1" :value="obj.pessoaNome" />
          <TableColumn :IsText="true" :status="1" :value="obj.gerenteNome" />
          <TableColumn :IsText="true" :status="1" :value="obj.tipoDespesaNome" />
          <TableColumn :IsText="true" :status="1" :value="toCurrency(obj.valorDespesa)" />
        </template>
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'
import SearchScreen from './search/search.vue'
import ReportDespesasRepository from '@/shared/http/repositories/despesas/report.js'

export default {
  name: 'ReportCrm',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      filters: null,
      columns: [
        'Data',
        'Hora',
        'Cliente',
        'Gerente',
        'Tipo de despesa',
        'Valor da despesa'
      ]
    }
  },
  mounted () {
    this.$eventHub.on('Filter', ({ filters }) => {
      this.filters = filters
      this.$refs.tableGrid.Clear()

      this.$nextTick(() => {
        this.onLoadAll()
      })
    })
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    toCurrency (valor) {
      if (!valor || isNaN(+valor)) {
        return null
      }
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor)
    },
    onLoad () {
      if (!this.filters) {
        this.filters = {
          usuarioId: null,
          periodo: null
        }
      }

      this.onShowSearch()
    },
    onLoadAll () {
      loading.push()
      ReportDespesasRepository.GetAllDespesas(this.filters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch(this.onException)
    },
    async onExport () {
      loading.push()

      await ReportDespesasRepository.GetPdf(this.filters)
        .then((response) => {
          const fileStartName = new Date().toLocaleString('pt-BR').replace(/[^0-9]/g, '')
          const blob = new Blob([this.base64ToArrayBuffer(response.data)], { type: 'application/pdf' })
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = `${fileStartName}_RelatorioDespesas.pdf`
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(this.onException)

      loading.close()
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onShowSearch () {
      let aside = {
        title: 'Filtros',
        self: this,
        component: SearchScreen
      }
      this.$eventHub.emit('Search', aside)
    }
  }
}
</script>
<style>
.popover-header {
  background-color: #04a791;
  color: #eceff1
}
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/reports/despesas/ReportDespesas.vue